<template>
  <div class="vr-container">
    <div class="dxyg-container" ref="dxygContainer" @click="onDocumentMouseDown($event)"></div>
    <template v-if="progress != 100">
      <div class="loading"></div>
      <div class="progress">
        <img src="@/assets/Loading.png" alt="" class="progress-loading"/>
        <span>场景加载中：{{ progress }}%</span>
      </div>
    </template>
    <div class="vr-container-footer">
      <div class="vr-container-footer-item" v-for="item in vrLists" :key="item.label"
           :class="{active: item.label === selectLabel}" @click="showOneMesh(item.label)">
        <img :src="item.image"/>
        <div>{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {equipList} from "@/api/lsyn2.js"

import * as THREE from 'three';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
import {RGBELoader} from 'three/examples/jsm/loaders/RGBELoader';
import gsap from 'gsap';
import {CSS2DRenderer, CSS2DObject} from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import {
  l1PosList,
  l2PosList,
  l3PosList,
  l4PosList,
  l5PosList,
  l6PosList,
  l7PosList,
  l8PosList,
  l9PosList,
  l10PosList,
  l11PosList,
  l1DeviceList,
  l2DeviceList,
  l3DeviceList,
  l4DeviceList,
  l5DeviceList,
  l6DeviceList,
  l7DeviceList,
  l8DeviceList,
  l9DeviceList,
  l10DeviceList,
  l11DeviceList,
} from './points.js'


import img1 from '../../assets/textures/img1.jpg';
import img2 from '../../assets/textures/img2.jpg';
import img3 from '../../assets/textures/img3.jpg';
import img4 from '../../assets/textures/img4.jpg';
import img5 from '../../assets/textures/img5.jpg';
import img6 from '../../assets/textures/img6.jpg';
import img7 from '../../assets/textures/img7.jpg';
import img8 from '../../assets/textures/img8.jpg';
import img9 from '../../assets/textures/img9.jpg';
import img10 from '../../assets/textures/img10.jpg';
import img11 from '../../assets/textures/img11.jpg';

import moveIcon from '../../assets/move.gif';
import flyIcon from '../../assets/fly.gif';

import bzIcon from '../../assets/textures/icon/bz.png'
import cqIcon from '../../assets/textures/icon/cq.png'
import qxIcon from '../../assets/textures/icon/qx.png'

import sqIcon from '../../assets/textures/icon/sq.png'
import szIcon from '../../assets/textures/icon/sz.png'

// 引入stats.js
import Stats from 'three/examples/jsm/libs/stats.module.js'
import {Vector3} from "three";

const stats = new Stats()


var camera, scene, renderer, control, axes, css2dRenderer, css2dScene, group, groupJCDevice, groupBox;
var geometry, boxMaterials = [], textures = [], cube;

var fov = 50, near = 25, far = 90;

const offset = new THREE.Vector3();
const spherical = new THREE.Spherical();
const sphericalDelta = new THREE.Spherical();
sphericalDelta.set(0, 0, 0);
const target = new THREE.Vector3();
var quat, quatInverse;


export default {
  name: "index",
  data() {
    return {
      selectLabel: 'l1',
      progress: 0,
      vrLists: [
        {
          label: 'l1',
          image: img1,
          name: '稻乡渔歌全貌'
        },
        {
          label: 'l2',
          image: img2,
          name: '大美大邑'
        },
        {
          label: 'l3',
          image: img3,
          name: '游客中心'
        },
        {
          label: 'l4',
          image: img4,
          name: '膳食研究所'
        },
        {
          label: 'l5',
          image: img5,
          name: '乐农学院'
        }, {
          label: 'l6',
          image: img6,
          name: '稻乡渔歌艺术'
        }, {
          label: 'l7',
          image: img7,
          name: '朗星家庭农场'
        }, {
          label: 'l8',
          image: img8,
          name: '稻鸭渔立体综'
        }, {
          label: 'l9',
          image: img9,
          name: '仓储加工中心'
        }, {
          label: 'l10',
          image: img10,
          name: '大地之眼'
        }, {
          label: 'l11',
          image: img11,
          name: '美好村'
        }
      ],
      deviceList: [],

    }
  },
  computed: {
    scaleBox() {
      return this.$store.getters.getScale || 1
    }
  },
  async mounted() {
    await this.getAllDevice()
    this.init();
    this.animate()
    this.selectLabel = 'l1'
    this.createQJT('l1', true);

    window.addEventListener('resize', this.onWindowResize, {
      passive: false
    });
    window.addEventListener('mousewheel', this.mousewheel, {
      passive: false
    });
    this.debounceRotate = this.debounce(this.resizeAutoRotate, 3000);
  },
  beforeDestroy() {
    console.log('beforeDestroy')
    window.removeEventListener('resize', this.onWindowResize);
    window.removeEventListener('mousewheel', this.mousewheel);
    this.tsDestory(true)
  },
  methods: {
    onDocumentMouseDown(event) {
      // event.preventDefault();
      // var vector = new THREE.Vector3();//三维坐标对象
      // vector.set(
      //     (event.clientX / window.innerWidth) * 2 - 1,
      //     -(event.clientY / window.innerHeight) * 2 + 1,
      //     0.5);
      // vector.unproject(camera);
      // var raycaster = new THREE.Raycaster(camera.position, vector.sub(camera.position).normalize());
      // var intersects = raycaster.intersectObjects(scene.children);
      // console.log('intersects', intersects)
      // if (intersects.length > 0) {
      //   var selected = intersects[intersects.length - 1];//取第一个物体
      //   console.log("x坐标:" + selected.point.x);
      //   console.log("y坐标:" + selected.point.y);
      //   console.log("z坐标:" + selected.point.z);
      // }
      control.autoRotate = false; //将自动旋转关闭
      this.debounceRotate()
    },
    resizeAutoRotate() {
      camera.updateProjectionMatrix();

      renderer.render(scene, camera);
      css2dRenderer.render(scene, camera);
      control.autoRotate = true; //将自动旋转关闭
    },
    // 防抖
    debounce(fn, delay) {
      let timer = null;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(fn, delay);
      };
    },
    onWindowResize() {
      console.log('onWindowResize');
      if (camera && renderer && css2dRenderer) {
        camera.aspect = window.innerWidth / window.innerHeight;

        camera.updateProjectionMatrix();
        const scaleBox = this.scaleBox;
        renderer.setSize(window.innerWidth / scaleBox, window.innerHeight / scaleBox);

        css2dRenderer.setSize(window.innerWidth / scaleBox, window.innerHeight / scaleBox);

        renderer.render(scene, camera);
        css2dRenderer.render(scene, camera);

        // renderer.setSize( window.innerWidth, window.innerHeight );
      }
    },
    animate() {
      control.update();
      // stats.update()

      renderer.render(scene, camera);
      css2dRenderer.render(scene, camera);
      requestAnimationFrame(this.animate);
    },
    init() {
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 5000);
      // camera = new THREE.OrthographicCamera( window.innerWidth / - 2, window.innerWidth / 2,  window.innerHeight / 2,  window.innerHeight / - 2, 0.11, 5000 );
      // so camera.up is the orbit axis
      quat = new THREE.Quaternion().setFromUnitVectors(camera.up, new THREE.Vector3(0, 1, 0));
      quatInverse = quat.clone().invert();

      //创建渲染器
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        precision: 'lowp',
        preserveDrawingBuffer: true,
        depth: false,
        logarithmicDepthBuffer: false,
      });
      const scaleBox = this.scaleBox;
      renderer.setSize(window.innerWidth / scaleBox, window.innerHeight / scaleBox);
      // renderer.setPixelRatio(window.devicePixelRatio);
      // renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.outputEncoding = THREE.LinearEncoding;
      // 添加渲染器
      this.$refs.dxygContainer.appendChild(renderer.domElement);

      // 设置stats样式
      // stats.dom.style.position = 'absolute';
      // stats.dom.style.top = '0px';
      // stats.dom.style.right = '0px';
      // this.$refs.dxygContainer.appendChild(stats.dom);

      css2dRenderer = new CSS2DRenderer({
        antialias: true,
      });
      css2dRenderer.setSize(window.innerWidth / scaleBox, window.innerHeight / scaleBox);
      css2dRenderer.domElement.style.position = 'absolute';
      css2dRenderer.domElement.style.top = '0px';
      css2dRenderer.domElement.style.left = '0px';
      css2dRenderer.domElement.style.pointerEvents = 'none';
      // 添加渲染器
      this.$refs.dxygContainer.appendChild(css2dRenderer.domElement);

      // 添加控制器
      control = new OrbitControls(camera, renderer.domElement);
      control.autoRotate = true; //将自动旋转关闭
      control.autoRotateSpeed = 1; //设置自动旋转速度
      control.enableDamping = true; //启用阻尼
      control.dampingFactor = 0.1; // 阻尼系数
      control.enableRotate = true; //启用旋转
      control.enablePan = false; //启用平移
      control.enableZoom = false; //启用缩放
      // control.mouseButtons = { LEFT: THREE.MOUSE.ROTATE, RIGHT:THREE.MOUSE.MIDDLE  };
      // control.addEventListener('change',this.animate)

      // 添加辅助坐标系
      // axes = new THREE.AxesHelper(500);
      // scene.add(axes);

      // 设置相机位置
      // camera.position.set(-200, -500, 50);
      // camera.lookAt(-500, -1000, 0);
      // control.update();

      THREE.DefaultLoadingManager.onProgress = (item, loaded, total) => {
        // console.log(item, loaded, total);
        this.progress = new Number((loaded / total) * 100).toFixed(2);
        console.log('进度:', this.progress);
      };
    },
    //鼠标滑轮-鼠标上下滑轮实现放大缩小效果
    mousewheel(e) {
      // console.log(e,"eeeeeeeeeeeeee=============>")
      if (e.target.nodeName !== 'CANVAS') return
      e.preventDefault();
      //e.stopPropagation();
      if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
        if (e.wheelDelta > 0) { //当滑轮向上滚动时
          fov -= (near < fov ? 1 : 0);
        }
        if (e.wheelDelta < 0) { //当滑轮向下滚动时
          fov += (fov < far ? 1 : 0);
        }
      } else if (e.detail) {  //Firefox滑轮事件
        if (e.detail > 0) { //当滑轮向上滚动时
          fov -= 1;
        }
        if (e.detail < 0) { //当滑轮向下滚动时
          fov += 1;
        }
      }

      //改变fov值，并更新场景的渲染
      camera.fov = fov;
      camera.updateProjectionMatrix();

      renderer.render(scene, camera);
      css2dRenderer.render(scene, camera);
    },
    resetCamera() {
      //改变fov值，并更新场景的渲染
      fov = 60;
      camera.fov = fov;
      camera.updateProjectionMatrix();
      renderer.render(scene, camera);
      css2dRenderer.render(scene, camera);
    },
    createQJT(name,
              isNeedCreated = false,
              position = new THREE.Vector3(0, 0, 0),
              euler = new THREE.Euler(0, 0, 0)) {
      this.resetCamera();

      var arr = [
        `1.right`,
        `1.left`,
        `1.top`,
        `1.bottom`,
        `1.front`,
        `1.back`,
      ];
      if (isNeedCreated) {

// 创建立方体
//       geometry = new THREE.BoxGeometry(2000, 2000, 2000);
//       geometry.scale(1, 1, -1);
        //       geometry = new THREE.BoxGeometry(2000, 2000, 2000);
        geometry = new THREE.BoxGeometry(200, 200, 200);
        // geometry.scale(20, 20, -20);
        // geometry.scale(20, 20, -20);
        geometry.scale(1, 1, -1);
        //let roomIndex = 0;
        //right    left    top      bottom   back     front
        //l r u d b f
        //px nx py ny pz nz

        boxMaterials = [];
        textures = [];
        arr.forEach((item) => {
          // 纹理加载
          const texture = new THREE.TextureLoader().load(`https://daoxiangyuge-1314050245.cos.ap-chengdu.myqcloud.com/textures/${name}/${item}.jpg`);
          // if (item === `1.top` || item === `1.bottom`) {
          //   texture.rotation = Math.PI;
          //   texture.center = new THREE.Vector2(0.5, 0.5);
          // }
          textures.push(texture);
          boxMaterials.push(
              new THREE.MeshBasicMaterial({
                side: THREE.DoubleSide,
                map: texture,
                // transparent: true,
                // opacity: 0.8,
                // depthWrite: true,
                // depthTest: true,
              })
          );
        });
        cube = new THREE.Mesh(geometry, boxMaterials);
        cube.position.copy(position);
        cube.rotation.copy(euler);
        scene.add(cube);
      } else {
        boxMaterials = [];
        textures = [];
        cube.material.forEach((item, index) => {
          let _url = arr[index];
          const texture = new THREE.TextureLoader().load(`https://daoxiangyuge-1314050245.cos.ap-chengdu.myqcloud.com/textures/${name}/` + _url + '.jpg');
          item.map.dispose();
          item.map = texture;
        });
      }
      this.resizeSJ()
      this.createLabel()
      this.createJCDevice()
      console.log('111111111', cube)

    },
    resizeSJ() {
      const label = this.selectLabel;
      var _position = new THREE.Vector3(0, 0, 0);
      switch (label) {
        case "l1":
          _position.set(-50, 60, 30);
          break;
        case "l2":
          _position.set(50, 60, 0);
          break;
        case "l3":
          _position.set(-10, 30, -50);
          break;
        case "l4":
          _position.set(-50, 60, 0);
          break;
        case "l5":
          _position.set(50, 30, 50);
          break;
        case "l6":
          _position.set(50, 30, 30);
          break;
        case "l7":
          _position.set(-20, 10, -30);
          break;
        case "l8":
          _position.set(50, 30, 20);
          break;
        case "l9":
          _position.set(10, 30, 50);
          break;
        case "l10":
          _position.set(50, 60, -90);
          break;
        case "l11":
          _position.set(-50, 40, -50);
          break;
        default:
          _position.set(0, 10, 0);
          break;
      }
      // 设置相机位置
      _position.set(_position.x / 5, _position.y / 5, _position.z / 5)
      camera.position.copy(_position);
      camera.lookAt(0, 0, 0);
      // camera.position.set(0, 50, 0);
      // camera.lookAt(0,0, 0);
      control.update();

    },
    createLabel() {
      const label = this.selectLabel;
      group = new THREE.Group();
      let list = [];
      switch (label) {
        case "l1":
          list = l1PosList
          break;
        case "l2":
          list = l2PosList
          break;
        case "l3":
          list = l3PosList
          break;
        case "l4":
          list = l4PosList
          break;
        case "l5":
          list = l5PosList
          break;
        case "l6":
          list = l6PosList
          break;
        case "l7":
          list = l7PosList
          break;
        case "l8":
          list = l8PosList
          break;
        case "l9":
          list = l9PosList
          break;
        case "l10":
          list = l10PosList
          break;
        case "l11":
          list = l11PosList
          break;
        default:
          list = []
          break;
      }
      list.map((item) => {
        const {x, y, z, content, label} = item;
        const box = this.createLableObj(content, x / 10, y / 10, z / 10, label);
        group.add(box);
      });
      if (label != 'l1') {
        const box = this.createLableObj('稻乡渔歌全貌', 15, 15, -15, 'l1', true);
        group.add(box);
      }
      scene.add(group);
    },
    createLableObj(text, x, y, z, label, isBack = false) {
      let divBox = document.createElement("div"); //创建div容器
      divBox.className = "laber-box";
      let laberDiv = document.createElement("div"); //创建div容器
      laberDiv.className = "laber_name";
      laberDiv.innerHTML = text;
      divBox.appendChild(laberDiv);

      if (isBack) {
        let img = document.createElement("img"); //创建div容器
        img.src = flyIcon
        img.className = 'laber-move'
        divBox.appendChild(img);
      } else if (label) {
        let img = document.createElement("img"); //创建div容器
        img.src = moveIcon
        img.className = 'laber-move'
        divBox.appendChild(img);
      } else {
        let lineDiv = document.createElement("div"); //创建div容器
        lineDiv.className = 'laber-line'
        let cicleDiv = document.createElement("div"); //创建div容器
        cicleDiv.className = 'laber-cicle'
        divBox.appendChild(lineDiv);
        divBox.appendChild(cicleDiv);
      }

      divBox.style.pointerEvents = 'auto';
      divBox.onclick = () => {
        console.log('点击了', label)
        if (label) {
          this.showOneMesh(label)
        }
      }

      let pointLabel = new CSS2DObject(divBox);

      pointLabel.position.set(x, y, z);
      pointLabel.center.set(0.5, 1);
      // pointLabel.layers.set( 1 );
      return pointLabel;
    },
    createJCDevice() {
      groupJCDevice = new THREE.Group();
      var deviceIcon = {
        'bz': bzIcon,
        'cq': cqIcon,
        'qx': qxIcon,
        'sq': sqIcon,
        'sz': szIcon
      }
      const deviceList = this.deviceList;
      // console.log('deviceList', deviceList)
      const label = this.selectLabel;
      let _list = [];
      switch (label) {
        case "l1":
          _list = l1DeviceList;
          break;
        case "l2":
          _list = l2DeviceList;
          break;
        case "l3":
          _list = l3DeviceList;
          break;
        case "l4":
          _list = l4DeviceList;
          break;
        case "l5":
          _list = l5DeviceList;
          break;
        case "l6":
          _list = l6DeviceList;
          break;
        case "l7":
          _list = l7DeviceList;
          break;
        case "l8":
          _list = l8DeviceList;
          break;
        case "l9":
          _list = l9DeviceList;
          break;
        case "l10":
          _list = l10DeviceList;
          break;
        case "l11":
          _list = l11DeviceList;
          break;
      }
      const list = _list.map(m => {
        const device = deviceList.find(n => n.id == m.id) || {};
        return {
          ...m,
          ...device,
          name: device.name || device.productName || device.typeName,
          icon: deviceIcon[m.label],
        }
      })
      list.forEach(m => {
        var box = this.createJCOneDevice(m);
        groupJCDevice.add(box);
      })
      scene.add(groupJCDevice);
    },
    // sq 墒情 ，bz 孢子 ，cq  虫情 ,qx 气象 ，sz 水质
    createJCOneDevice(row) {
      let divBox = document.createElement("div"); //创建div容器
      divBox.className = "device-container";

      divBox.innerHTML = `
      <div class="device-container-box ${row.label}" style="display: none;">
   <!--      <div class="device-container-title" id="name">${row.name || '--'}</div>-->
        <div class="device-container-content" id="content" style="padding: 11px">
          <div class="name ${row.label}" style="min-width: 250px;">${row.name || '--'}</div>
<!--          <div class="info-item">当前区域种植面积：<span style="color:rgba(1, 194, 255, 1)">12</span>公顷 </div>-->
<!--          <div class="info-item">当前作物种植总面积：<span style="color:rgba(1, 194, 255, 1)">125</span>公顷 </div>-->
<!--          <div class="info-item">作物总产量：<span style="color:rgba(255, 195, 0, 1)">1258</span>斤 </div>-->
<!--          <div class="info-item">作物总产值：<span style="color:rgba(255, 141, 26, 1)">125899</span>元 </div>-->
<!--          <div class="info-item">板块地址：四川省稻香渔歌</div>-->
                <div class="info-item">设备状态：<span style="color:${row.state == 'online' ? '#67C23A' : row.state == 'offline' ? '#F56C6C' : row.state == 'fault' ? '#E6A23C' : '#909399'}">${row.state == 'online' ? '在线' : row.state == 'offline' ? '离线' : row.state == 'fault' ? '故障' : '无'}</span></div>
                <div class="info-item">所属分类：${row.typeName}</div>
                <div class="info-item">所属产品：${row.productName}</div>
                <div class="info-item">设备地址：${row.baseAddress}</div>
        </div>
      </div>`

      let img = document.createElement("img"); //创建div容器
      img.src = row.icon;
      img.className = 'device-container-icon'
      divBox.appendChild(img);
      let isShow = false;
      // TODO AD
      img.style.pointerEvents = 'auto';
      img.onclick = () => {

        if (isShow) {
          // divBox.getElementsByClassName('device-container-title')[0].style.display = 'block';
          divBox.getElementsByClassName('device-container-box')[0].style.display = 'none';
          isShow = false
        } else {
          // divBox.getElementsByClassName('device-container-title')[0].style.display = 'none';
          divBox.getElementsByClassName('device-container-box')[0].style.display = 'block';
          isShow = true
        }
      }

      let pointLabel = new CSS2DObject(divBox);

      pointLabel.position.set(row.x / 10, row.y / 10, row.z / 10);
      pointLabel.center.set(0.5, 1);
      // pointLabel.layers.set( 1 );
      return pointLabel;
    },
    showOneMesh(label = 'l1') {
      this.progress = 0
      this.selectLabel = label
      // var geometry, boxMaterials = [], textures = [], cube;
      this.tsDestory(false)
      // console.log('label', scene)
      this.createQJT(label, false);

      // if (scene) {
      //   var arr = [
      //     `1.right`,
      //     `1.left`,
      //     `1.top`,
      //     `1.bottom`,
      //     `1.front`,
      //     `1.back`,
      //   ];
      //   cube.material.forEach((item, index) => {
      //     let _url = arr[index];
      //     const texture = new THREE.TextureLoader().load(`./textures/${name}/` + _url + '.jpg');
      //     // if (_url === `${name}_top` || _url === `${name}_bottom`) {
      //     //   texture.rotation = Math.PI;
      //     //   texture.center = new THREE.Vector2(0.5, 0.5);
      //     // }
      //     item.map.dispose();
      //     item.map = texture;
      //   });
      //
      // }
    },
    tsDestory(isDelete) {
      if (scene) {
        if (cube && isDelete) {
          scene.remove(cube)
          cube = null
        }
        if (geometry && isDelete) {
          geometry.dispose()
          geometry = null
        }
        if (boxMaterials && boxMaterials.length && isDelete) {
          boxMaterials.map(item => {
            item.dispose()
          })
          boxMaterials = []
        }
        if (textures && textures.length) {
          textures.map(item => {
            item.dispose()
          })
          textures = []
        }
        if (group) {
          group.remove(...group.children)
          scene.remove(group)
          group = null
        }
        if (groupJCDevice) {
          groupJCDevice.remove(...groupJCDevice.children)
          scene.remove(groupJCDevice)
          groupJCDevice = null
        }
        if (groupBox) {
          groupBox.remove(...groupBox.children)
          scene.remove(groupBox)
          groupBox = null
        }

      }
    },
    getAllDevice() {
      // 获取设备列表
      return equipList({
        pageNum: 1,
        pageSize: 1000,
      }).then(res => {
        if (res.code == '200') {
          this.deviceList = res.data.list
        }
      })
    }
  }
}
</script>


<style scoped lang="less">
.vr-container {
  width: 100%;
  height: 100%;
  position: relative;
  //cursor: all-scroll;

  &-footer {
    z-index: 100;
    position: absolute;
    bottom: 105px;
    width: 100%;
    height: 106px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    //background: rgba(0, 0, 0, 0.3);
    gap: 5px;

    &-item {
      width: 73px;
      height: 73px;
      object-fit: cover;
      border: 3px solid #fff;
      position: relative;
      cursor: pointer;

      & > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      & > div {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 22px;
        background-color: rgba(0, 0, 0, .5);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: white;
      }

      &.active {
        border-color: #f6b64c;
      }
    }
  }
}

.dxyg-container {
  width: 100%;
  height: 100%;
}

.loading {
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-image: url(~@/assets/loading.jpg);
  filter: blur(50px);
  z-index: 150;
}

.progress {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #fff;
  z-index: 150;
}

.progress > img {
  padding: 0 15px;
  animation: rotateLoading 2s linear infinite;
}

@keyframes rotateLoading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

</style>
<style lang="less">
.laber-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 60px;
  cursor: pointer;
}

.laber_name {
  padding: 5px;
  border-radius: 5px;
  color: #FFF;
  font-family: sans-serif;
  background: rgba(0, 0, 0, .6);
  font-size: 12px;
}

.laber-line {
  width: 2px;
  height: 30px;
  flex: 1;
  background: #fff;
}

.laber-cicle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
}

.laber-move {
  flex: 1;
  width: 33px;
  height: 44px;
  object-fit: contain;
}

.device-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  &-box {
    background-size: 100% 100%;
    width: 100%;
    padding: 5px 15px 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 8px;
    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 10px), calc(50% + 5px) calc(100% - 10px), 50% 100%, calc(50% - 5px) calc(100% - 10px), 0 calc(100% - 10px));

    &.bz {
      background: rgba(64, 26, 18, 0.87);
      border: 1px solid rgba(250, 106, 90, 0.7);
      box-shadow: inset 0px 1px 15px rgba(255, 72, 0, 0.6);
    }

    &.cq {
      background: rgba(64, 37, 18, 0.87);
      border: 1px solid rgba(250, 149, 90, 0.7);
      box-shadow: inset 0px 1px 15px rgba(255, 167, 3, 0.6);
    }

    &.qx {
      background: rgba(64, 63, 18, 0.87);
      border: 1px solid rgba(250, 223, 90, 0.7);
      box-shadow: inset 0px 1px 15px rgba(255, 251, 0, 0.6);
    }

    &.sq {
      background: rgba(18, 56, 64, 0.87);
      border: 1px solid rgba(89, 175, 249, 0.7);
      box-shadow: inset 0px 1px 15px rgba(3, 251, 255, 0.6);
    }

    &.sz {
      background: rgba(18, 64, 58, 0.87);
      border: 1px solid rgba(90, 250, 173, 0.7);
      box-shadow: inset 0px 1px 15px rgba(3, 255, 251, 0.6);
    }
  }

  &-title {
    width: 100%;
    text-align: center;
    background-size: 100% 100%;
    font-size: 14px;
    font-weight: bold;
  }

  &-icon {
    width: 24px;
    height: 60px;
    object-fit: contain;
  }

  .name {
    font-size: 16px;
    font-weight: 700;
    color: rgba(1, 194, 255, 1);
    text-align: center;
    letter-spacing: 1px;
    margin-bottom: 6px;

    &.bz {
      color: rgba(255, 72, 0, 0.6);
    }

    &.cq {
      color: rgba(255, 167, 3, 0.6);
    }

    &.qx {
      color: rgba(255, 251, 0, 0.6);
    }

    &.sq {
      color: rgba(3, 251, 255, 0.6);
    }

    &.sz {
      color: rgba(3, 255, 251, 0.6);
    }
  }

  .info-item {
    font-size: 14px;
    line-height: 25px;
    color: rgba(222, 240, 255, 1);

    span {
      margin-right: 4px;
      font-weight: 600;
    }
  }

}

</style>
